import { ResetPasswordComponent } from './reset-password.component';
import { Route } from '@angular/router';

export const resetPasswordRoutes: Array<Route> = [
  {
    path: 'reset',
    component: ResetPasswordComponent
  },
  {
    path: 'reset/forced',
    component: ResetPasswordComponent,
    data: { forced: true }
  },
  {
    path: 'reset/:token',
    component: ResetPasswordComponent
  }
];
